import { RgDefaults as r, RgCreate as s, RvDataListSets as u, RgDataSetID as D } from "@project-rouge/rg-core";
const f = (e, a = u[D.uk_01]) => {
  const o = r[e.type], t = s({
    ...o,
    ...e
  }, a);
  return t.data = { ...t.data }, t;
};
export {
  f as RgDefaultCreate
};
//# sourceMappingURL=index28.js.map
